import { type PayloadAction } from '@reduxjs/toolkit';
import { get } from 'lodash';

import { createSlice } from '@/lib/redux/createSlice';
import { CompanyService } from '@/lib/services/company';

import { initialState } from './initialState';
import type { ICompany } from '@enl/type-definitions';

const slice = createSlice({
  name: 'company',
  initialState: initialState,
  reducers: (create) => {
    return {
      createCompany: create.asyncThunk<
        ICompany,
        Omit<ICompany, 'branding'>,
        { rejectValue: string }
      >(
        async (payload) => {
          const createdCompany = await CompanyService.createCompany(payload);
          return createdCompany;
        },
        {
          pending: (state) => {
            state.loading = true;
          },
          options: {
            condition: (_, api) => {
              const x = api.getState();
              const isLoading = get(x, 'company.loading', false);
              return !isLoading;
            },
          },
          rejected: (state) => {
            state.loading = false;
          },
          fulfilled: (state, action: PayloadAction<ICompany>) => {
            state.loading = false;
            state.data = action.payload;
          },
        }
      ),
    };
  },
});

export default slice;
